import { getter, orderBy } from "@progress/kendo-data-query";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Loader } from "@progress/kendo-react-indicators";
import moment from "moment";
import { forwardRef, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { AnnouncementServices } from "src/services/announcementService";
const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);
const ReadByBAA = forwardRef(({ title, onClose }, ref) => {
  const [isFetching, setIsFetching] = useState(true);
  const [clinicsAcknowledgedList, setClinicsAcknowledgedList] = useState([]);
  const location = useLocation()
  const pageChange = (event) => {
    setPage(event.page.skip);
    setPageSize(event.page.take);
  };
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);


  const [sort, setSort] = useState([]);
  const navigate = useNavigate();
  const [selectedState, setSelectedState] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsFetching(true);
        const result = await AnnouncementServices.GetBaaAcknowledgementHistory();
        setClinicsAcknowledgedList(result?.resultData || []);
      } catch (error) {
        console.error("Failed to fetch BAA acknowledgement history", error);
      } finally {
        setIsFetching(false);
      }
    };

    fetchData();
  }, []);

  return (
    <Dialog
      width="70%"
      height="70%"
      style={{ overflowY: "auto" }}
      onClose={onClose}
      title={title}
    >
      {isFetching ? (
        <Loader />
      ) : (
          <Grid
            data={orderBy(
              clinicsAcknowledgedList.slice(page, page + pageSize),
              sort
            ).map((item) => ({
              ...item,
              [SELECTED_FIELD]: selectedState[idGetter(item)],
            }))}                  
            skip={page}
            take={pageSize}
            onPageChange={pageChange}
            total={clinicsAcknowledgedList.length}
            pageable={{
              pageSizes: [10, 25, 50, 100, 250, 500],
            }}
            selectedField={SELECTED_FIELD}
            dataItemKey={DATA_ITEM_KEY}
            sort={sort}
            sortable={true}
            scrollable="none"
          >
          <GridColumn
              title="Clinic"
              field="clinicName"
          />
          <GridColumn
              title="Acknowledged By"
              field="acknowledgeByName"
          />

          <GridColumn
              title="Date"
              field="acknowledgeDate"
              cells={{
                data: (props) => (
                  <td>
                  {props.dataItem?.acknowledgeDate
                      ? moment(props.dataItem.acknowledgeDate)
                          .local()
                          .format("M/D/YYYY")
                      : "-"}
                  </td>
              ),
              }}
          />
        </Grid>
      )}

      <DialogActionsBar>
        {/* buttons if needed */}
      </DialogActionsBar>
    </Dialog>
  );
});

export default ReadByBAA;